export default __webpack_public_path__ + "static/media/vectorRight.254b053f.svg";